var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { alertState, checkTypeState } from "../../../../../recoil/assessmentState";
import { reLoad, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import dayjs from "dayjs";
import { langId } from "../../../../../recoil/langState";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import * as CONST from "../../../../../utils/Const";
import { useTrans } from "../../../../../utils/langs/useTrans";
function CheckPreviousInspection() {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const reload = useRecoilValue(reLoad);
    const langIds = useRecoilValue(langId);
    const [preInspectionItem, setPerInspectionItem] = useState([]);
    let appPath = `?itemId=${check.itemInfo.id}`;
    // 이전이력  API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessments${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setPerInspectionItem(data.body);
            }
        }
    }, [data, langIds]);
    // 취소
    function StepClose(e) {
        setCheck(Object.assign(Object.assign({}, check), { nextStep: check.preStep, assessmentId: -1 }));
    }
    function PreClick(item) {
        setCheck(Object.assign(Object.assign({}, check), { assessmentId: item.assessmentId, chekTypeInfo: {
                checkTypeId: check.chekTypeInfo.checkTypeId,
                checkTypeName: item.checkTypeName,
            }, chekSubTypeInfo: {
                checkSubTypeId: -1,
                checkSubName: item.checkSubTypeName,
            }, chekVersionTypeInfo: {
                checkVersionId: -1,
                versionNo: item.versionNo,
            }, assessmentInfo: {
                isTempSave: item.isTempSave,
                reportId: !item.reportId ? -1 : item.reportId,
            } }));
    }
    // 다음 step
    function NextStep(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (check.assessmentId > 0) {
                if (check.assessmentInfo.isTempSave) {
                    setCheck(Object.assign(Object.assign({}, check), { nextStep: "step3", preStep: "prelist" }));
                }
                else {
                    // 완료시 주셕처리 해줘요
                    /*     setCheck({
                                    ...check,
                                    nextStep: "result",
                                    preStep: "prelist",
                                    assessmentId: check.assessmentId
                                }) */
                    let data = null;
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "POST",
                        appPath: `/assessment`,
                        appQuery: {
                            preAssessmentId: check.assessmentId,
                            langId: langIds,
                        },
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setCheck(Object.assign(Object.assign({}, check), { nextStep: "step3", preStep: "prelist", assessmentId: data.body.assessmentId, chekTypeInfo: {
                                    checkTypeId: -1,
                                    checkTypeName: data.body.checkType,
                                }, chekSubTypeInfo: {
                                    checkSubTypeId: -1,
                                    checkSubName: data.body.checkSubType,
                                }, chekVersionTypeInfo: {
                                    checkVersionId: -1,
                                    versionNo: data.body.checkVersionNo,
                                }, assessmentInfo: {
                                    isTempSave: data.body.isTempSave,
                                    reportId: -1,
                                } }));
                        }
                        else {
                            // need error handle
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
            }
            else {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.불러올데이터선택") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        });
    }
    return (_jsx(_Fragment, { children: preInspectionItem && (_jsx("main", Object.assign({ className: "container" }, { children: _jsxs("section", Object.assign({ className: "content step2-1 " }, { children: [_jsx("div", Object.assign({ className: "top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.불러올데이터선택") })) })), _jsxs("div", Object.assign({ className: "bottom " }, { children: [_jsxs("div", Object.assign({ className: `tbl-area ${preInspectionItem.length <= 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "color-info flex-right mb-16" }, { children: [_jsx("p", Object.assign({ className: "ehc" }, { children: t("스케쥴.캘린더.LS") })), _jsx("p", Object.assign({ className: "etc" }, { children: t("스케쥴.캘린더.고객향점검") }))] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uC870\uD68C\uB41C \uC774\uC804 \uC810\uAC80 \uC774\uB825 \uB9AC\uC2A4\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." })), preInspectionItem.length > 0 && (_jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uC810\uAC80\uC77C, \uC720\uD615, \uC0C1\uC138\uC720\uD615, \uBC84\uC804, \uAD6C\uBD84, \uD30C\uC77C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC774\uC804 \uC810\uAC80 \uC774\uB825 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC774\uC804 \uC810\uAC80 \uC774\uB825 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "m-none" }, { children: [_jsx("col", { style: { width: "4px" } }), _jsx("col", { style: { width: "110px" } }), _jsx("col", { style: { width: "110px" } }), _jsx("col", { style: { width: "160px" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "80px" } }), _jsx("col", { style: { width: "40px" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "w5" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.점검유형") })) })), _jsx("th", Object.assign({ scope: "col", className: "sort desc" }, { children: _jsx("span", { children: t("라벨.점검일") }) })), _jsx("th", Object.assign({ scope: "col", className: "sort desc m-none" }, { children: _jsx("span", { children: t("라벨.유형") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.상세유형") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.버전") }) })), _jsx("th", Object.assign({ scope: "col", className: "sort desc m-none" }, { children: _jsx("span", { children: t("라벨.구분") }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center m-none" }, { children: _jsx("span", { children: "File" }) }))] }) }), _jsx("tbody", { children: preInspectionItem.map((item, idx) => (_jsxs("tr", Object.assign({ className: `${item.assessmentId == check.assessmentId ? "selected" : ""}`, onClick: (e) => PreClick(item) }, { children: [_jsx("td", { children: _jsx("span", Object.assign({ className: `${item.checkTypeName.split(" ", 1) == "LS" ? "ehc" : item.checkTypeName.split(" ", 1) == "직무고시" ? "jig" : "etc"}` }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "e-HC" })) })) }), _jsx("td", { children: dayjs(item.updatedTime).format("YYYY-MM-DD") }), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.checkTypeName })) })), _jsx("td", { children: item.checkSubTypeName }), _jsx("td", Object.assign({ className: `${item.versionNo.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": item.versionNo }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.versionNo })) })), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsxs("span", Object.assign({ className: "fontMedium txt-blue" }, { children: [" ", item.isTempSave == true && t("라벨.임시저장")] })) })), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC" })) })) }))] }), "preList_" + idx.toString()))) })] })) })))] })), _jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", disabled: check.preStep == "step3" ? true : false, onClick: (e) => StepClose(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", disabled: preInspectionItem.length <= 0 ? true : false, onClick: (e) => NextStep(e) }, { children: _jsx("span", { children: t("라벨.불러오기") }) }))] }))] }))] })) }))) }));
}
export default CheckPreviousInspection;
